import React, { useState, useEffect } from 'react';
import { Document, Page, View, Text, PDFViewer, Image, StyleSheet, pdf } from '@react-pdf/renderer';
import bannerSuperior from './bannerSuperior.png'
import bannerInferior from './bannerInferior.png'
import ImagenQR from '../tools/imagenQR';
import Logo from './image.png'
import logoProvincia from './image.png'
import textoIsep from '../certificados/logoProvinciaISeP2024.png'
import axios from 'axios';
import DameToken from '../tools/dameToken.js'
import { useLocation } from 'react-router-dom';
import { saveAs } from 'file-saver';
import firmaFunc from './firmaSimil.jpeg'

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });



  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowSize;
};
function Constancia() {
  function formatToThreeDigits(number) {
    if (number < 1 || number > 100) {

      return number
    }
    return number.toString().padStart(3, '0');
  }
  const { width, height } = useWindowSize();
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  const styles = StyleSheet.create({
    text: {
      fontFamily: 'Tahoma',
      fontSize: 12,
    },
  });
  const [muestro, setMuestro] = useState(false)
  const [Er, setEr] = useState(false)
  const [datosVarios, setDatosVarios] = useState(false)
  const [claseCertificad, setClaseCertificado] = useState()
  const [anio, setanio] = useState();
  const consulta = useQuery();

  const certificadoModel = (curso, certificado) => {

    const certificadoFinal = {
      "añoCertificado": strigAFecha(certificado.createdAt).getFullYear(),
      "idCurso": formatToThreeDigits(curso.id),
      "idCursante": formatToThreeDigits(certificado.id),
      "dniCertificado": certificado.dniCertificado,
      "apellidoNombre": certificado.apellidoNombre,
      "reginterno": curso.reginterno,
      "claseCertificado": curso.claseCertificado,
      "tituloCertificado": curso.tituloCertificado,
      "ciudadCertificado": curso.ciudadCertificado,
      "fechaciudadCertificado": curso.fechaciudadCertificado,

      "organizadoPor": curso.organizadoPor,
      "tipoCapacitacion": curso.tipoCapacitacion,
      "fechaRealizado": curso.fechaRealizado,
      "escudo1": curso.escudo1,
      "escudo2": curso.escudo2,
      "fechacursado": curso.fechacursado,
      "cantidadHoras": curso.cantidadHoras,
      "tipoHoras": curso.tipoHoras,
      "sedeCertificado": certificado.sedeCertificado,
      "resolucionCertificado": curso.resolucionCertificado,
      "resolucionJPP": curso.resolucionJPP,

      "grado": certificado.grado,
      "calidadDe": certificado.calidadDe,

      "cantidadFirmas": curso.cantidadFirmas,
      "firma1": curso.firma1,
      "firmante1": curso.firmante1,
      "firmante1jer": curso.firmante1jer,
      "firmante1cargo": curso.firmante1cargo,
      "firma2": curso.cantidadFirmas > 1 ? curso.firma2 : "",
      "firmante2": curso.cantidadFirmas > 1 ? curso.firmante2 : "",
      "firmante2jer": curso.cantidadFirmas > 1 ? curso.firmante2jer : "",
      "firmante2cargo": curso.cantidadFirmas > 1 ? curso.firmante2cargo : "",
      "firma3": curso.cantidadFirmas > 2 ? curso.firma3 : "",
      "firmante3": curso.cantidadFirmas > 2 ? curso.firmante3 : "",
      "firmante3jer": curso.cantidadFirmas > 2 ? curso.firmante3jer : "",
      "firmante3cargo": curso.cantidadFirmas > 2 ? curso.firmante3cargo : "",
      "firma4": curso.cantidadFirmas > 3 ? curso.firma4 : "",
      "firmante4": curso.cantidadFirmas > 3 ? curso.firmante4 : "",
      "firmante4jer": curso.cantidadFirmas > 3 ? curso.firmante4jer : "",
      "firmante4cargo": curso.cantidadFirmas > 3 ? curso.firmante4cargo : "",
      "firma5": curso.cantidadFirmas > 4 ? curso.firma5 : "",
      "firmante5": curso.cantidadFirmas > 4 ? curso.firmante5 : "",
      "firmante5jer": curso.cantidadFirmas > 4 ? curso.firmante5jer : "",
      "firmante5cargo": curso.cantidadFirmas > 4 ? curso.firmante5cargo : ""
    }


    setDatosVarios(certificadoFinal)
    setMuestro(true)
  }



  function mesYAnio(fechaRealizado) {
    if (!fechaRealizado) return "";

    const meses = [
      "enero", "febrero", "marzo", "abril", "mayo", "junio",
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];

    const texto = String(fechaRealizado).trim();

    // Texto libre:
    // "dictada el día 20 de mayo de 2026"
    // "del 20 al 25 de mayo de 2026"
    // "mayo 2026"
    const coincidenciaTexto = texto.match(
      /(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)\D*(\d{4})/i
    );

    if (coincidenciaTexto) {
      return `${coincidenciaTexto[1].toLowerCase()} ${coincidenciaTexto[2]}`;
    }

    // Fecha ISO: 2026-05-20 o 2026-05-20T00:00:00.000Z
    const coincidenciaIso = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);

    if (coincidenciaIso) {
      const anio = Number(coincidenciaIso[1]);
      const mes = Number(coincidenciaIso[2]);

      if (mes >= 1 && mes <= 12) {
        return `${meses[mes - 1]} ${anio}`;
      }
    }

    // Fecha argentina: 20/05/2026
    const coincidenciaArgentina = texto.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);

    if (coincidenciaArgentina) {
      const mes = Number(coincidenciaArgentina[2]);
      const anio = Number(coincidenciaArgentina[3]);

      if (mes >= 1 && mes <= 12) {
        return `${meses[mes - 1]} ${anio}`;
      }
    }

    // Último intento para otros formatos reconocidos por JavaScript
    const fechaConvertida = new Date(texto);

    if (!isNaN(fechaConvertida.getTime())) {
      return `${meses[fechaConvertida.getMonth()]} ${fechaConvertida.getFullYear()}`;
    }

    return "";
  }

  function fechaFormal() {
    const meses = [
      "enero", "febrero", "marzo", "abril", "mayo", "junio",
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];

    const hoy = new Date();
    const dia = hoy.getDate();
    const mes = meses[hoy.getMonth()];
    const anio = hoy.getFullYear();

    return `${dia} de ${mes} de ${anio}`;
  }
  function fechaFormal4() {
    const meses = [
      "enero", "febrero", "marzo", "abril", "mayo", "junio",
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];

    const hoy = new Date();
    const dia = hoy.getDate();
    const mes = meses[hoy.getMonth()];
    const anio = hoy.getFullYear();

    return `${dia} días del mes de ${mes} de ${anio}`;
  }


  function strigAFecha(dateString) {

    const date = new Date(dateString);


    if (isNaN(date)) {
      throw new Error('Fecha inválida');
    }

    return date;
  }

  const reemplazarEspacios = (str) => {
    return str.replace(/ /g, '%20'); // Reemplaza todos los espacios
  };
  const direccion = "https://certificados.isepsantafe.edu.ar?ni=" + consulta.get("ni") + "&curso=" + reemplazarEspacios(consulta.get('curso')) + "&Ra@=" + DameToken()



  const obtieneCertificado = async () => {
    const client = axios.create({
      baseURL: process.env.REACT_APP_BASEURL + "certificados/api-devuelveCertificados?ni=" + consulta.get("ni") + "&curso=" + consulta.get('curso') + "&Ra@=" + DameToken()
    });
    try {
      const datos = await client.post('/')
      if (datos) {
        if (datos.data.Cursante != "Nada que mostrar") {
          setanio(datos.data.Curso.createdAt)
          certificadoModel(datos.data.Curso, datos.data.cursante)
          setClaseCertificado(datos.data.Curso.claseCertificado)

          setMuestro(true)
        } else {
          setEr(true)
        }


      } else { setEr(true) }
    }
    catch (error) { }

  }


  const obtenerAnio = (fecha) => {
    return new Date(fecha).getFullYear();
  };
  useEffect(() => {

    obtieneCertificado()
    return () => {

    };
  }, []);


  function verificarString(cadena) {

    if (cadena > 6000000) {
      return "DNI";
    } else {
      return "N.I.";
    }
  }
  function fechaFormateadaArgentina() {
    const meses = [
      "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
      "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
    ];

    const ahora = new Date();

    // Obtener fecha en Argentina usando Intl
    const opcionesFecha = { timeZone: "America/Argentina/Buenos_Aires", year: "numeric", month: "numeric", day: "numeric", hour: "2-digit", minute: "2-digit", hour12: false };
    const formateador = new Intl.DateTimeFormat("es-AR", opcionesFecha);
    const partes = formateador.formatToParts(ahora);

    let dia, mes, año, hora, minuto;

    partes.forEach(({ type, value }) => {
      if (type === "day") dia = value;
      if (type === "month") mes = meses[parseInt(value) - 1]; // mes en letras
      if (type === "year") año = value;
      if (type === "hour") hora = value.padStart(2, "0");
      if (type === "minute") minuto = value.padStart(2, "0");
    });

    return `a los ${dia} días del mes de ${mes} del ${año}`;
  }

  const firmanteSimil = "Crio. General (R) Dardo E. Simil"
  const firmanteFuncion = "Subsecretario de Formación y Carrera Policial"
  const firmanteDestino = "Ministerio de Justicia y Seguridad"

  const hoyClase1 = mesYAnio(datosVarios.fechaRealizado)
  const text1Clase1 = `Se le otorga el presente certificado al`
  const text2Clase1 = ` ${datosVarios.grado ? datosVarios.grado : "ciudadano"} ${datosVarios.apellidoNombre} - ${verificarString(datosVarios.dniCertificado) + " N° " + datosVarios.dniCertificado}`
  const text3Clase1 = `Por haber participado de ${datosVarios.tituloCertificado}, en calidad de ${datosVarios.calidadDe}; ${datosVarios.organizadoPor} ${datosVarios.fechaRealizado}. `

  ///////////////////////secretaria academica
  const hoyClase4 = mesYAnio(datosVarios.fechaRealizado)
  const text1Clase4 = `La Escuela de Investigaciones I.Se.P otorga el presente certificado al ${datosVarios.grado ? datosVarios.grado : "ciudadano"}`
  const text2Clase4 = `  ${datosVarios.apellidoNombre} - ${verificarString(datosVarios.dniCertificado) + " N° " + datosVarios.dniCertificado}`
  const text3Clase4 = ` por haber aprobado satisfactoriamente el ${datosVarios.tituloCertificado} - ${datosVarios.reginterno}, según Resolución ${datosVarios.resolucionCertificado}. El curso se desarrolló ${datosVarios.fechaRealizado} con una carga horaria total de ${datosVarios.cantidadHoras}. `

  ///////////////////////TITULOS
  const ciudadMayuscula = (datosVarios.ciudadCertificado || "").toUpperCase();
  const text4Clase1 = `${ciudadMayuscula + ": " + hoyClase1 + ""}. `
  const hoy = fechaFormal()
  const text1 = `Se hace constar que `
  const text2 = `${datosVarios.apellidoNombre}, ${verificarString(datosVarios.dniCertificado) + " Nro. " + datosVarios.dniCertificado}, `
  const text3 = `ha finalizado y aprobado sus estudios de “${datosVarios.tituloCertificado}” ${datosVarios.organizadoPor}. 
    `
  const text3b = `ha finalizado y aprobado sus estudios de “${datosVarios.tituloCertificado}”, perteneciente a la Carrera de Técnico Superior en Seguridad Pública y Ciudadana con Orientacion Policial. en el establecimiento ${datosVarios.organizadoPor}. 
    `
  const text4 = `Encontrándose en trámite la expedición de su título definitivo.`

  const clase1_a = () => (
    <Document title={"Certificado " + datosVarios.tituloCertificado + " " + datosVarios.apellidoNombre} onLoadError={console.error}>
      <Page size="A4" orientation='landscape' >
        <View style={{ width: "100%", marginTop: "20px", marginLeft: "10px", padding: "1px" }}>
          <View id="Logos" style={{ width: "100%", marginTop: "20px", padding: "1px" }}>
            <Image style={{ width: "850px", position: "absolute", marginLeft: "-15px", marginTop: "-42px" }} src={bannerSuperior} />
            <Image style={{ width: "85px", position: "absolute", marginLeft: "90px", marginTop: "20px" }} src={logoProvincia} />

            <Image style={{ width: "320px", position: "absolute", marginTop: "40px", marginLeft: "450px" }} src={textoIsep} />


          </View>
          <Text style={{ textAlign: "center", marginTop: "130px", paddingTop: "1px", fontSize: "32px", fontWeight: "bold" }}>C   E   R   T   I   F   I   C   A   D   O</Text>

          <View className='datosPersonales_legajo' style={{ textAlign: "justify", marginLeft: "75px", marginRight: "85px", paddingTop: "1px", fontSize: "12px", lineHeight: "2" }}>


            <Text style={{ textAlign: "justify", paddingTop: "1px", fontSize: "16px", lineHeight: "2", marginTop: "50px", color: "#333" }}>{text1Clase1}<Text style={{ textAlign: "justify", fontSize: "18px", color: "black" }}>{text2Clase1}</Text>{text3Clase1}
            </Text>

            <Text style={{ textAlign: "rigth", fontSize: "16px", lineHeight: "2", color: "#333" }}>{"" + text4Clase1}</Text>
            <Text style={{ textAlign: "rigth", fontSize: "16px", lineHeight: "2" }}></Text>

             <View id="firmaDardo" style={{ width: "180px", position: "absolute", marginLeft: "350px", marginTop: "370px", lineHeight: "1", fontSize: "8px", textAlign: "center" }}>

              <Image style={{ width: "120px", position: "absolute", marginLeft: "20px", marginTop: "-90px", transform: 'rotate(-90deg)',}} src={firmaFunc} />

              <Text style={{ marginTop: "-10px" }} >{firmanteSimil}</Text>
              <Text style={{ textAlign: "center", }}>{firmanteFuncion}</Text>
              <Text >{firmanteDestino}</Text>

            </View>
            
            <View id="firmaDire" style={{ width: "110px", position: "absolute", marginLeft: "180px", marginTop: "272px", lineHeight: "1", fontSize: "8px", textAlign: "center" }}>
              <Image src={datosVarios.firma1} />
              <Text style={{ marginTop: "-10px" }} >{datosVarios.firmante1}</Text>
              <Text style={{ textAlign: "center", }}>{datosVarios.firmante1jer}</Text>
              <Text >{datosVarios.firmante1cargo}</Text>

            </View>


            <View id="QR" style={{ width: "150px", position: "absolute", marginLeft: "615px", marginTop: "280px" }}>
              <ImagenQR direccion={direccion} tamaño="110" /></View>
          </View>
          <View style={{ fontWeight: "bold", textAlign: "center", fontSize: "6px", position: "absolute", marginTop: "550px" }}>
            <Text style={{ fontSize: "8px", lineHeight: "2", marginLeft: "646px" }}>Nro. de Registro:{datosVarios.idCurso + "-" + datosVarios.idCursante + "-" + obtenerAnio(anio)}</Text>
          </View>
          <Image style={{ width: "850px", position: "absolute", marginLeft: "-15px", marginTop: "565px" }} src={bannerInferior} />
        </View>

      </Page>
    </Document>
  );
  const clase1 = () => (
    <Document title={"Certificado " + datosVarios.tituloCertificado + " " + datosVarios.apellidoNombre} onLoadError={console.error}>
      <Page size="A4" orientation='landscape' >
        <View style={{ width: "100%", marginTop: "20px", marginLeft: "10px", padding: "1px" }}>
          <View id="Logos" style={{ width: "100%", marginTop: "20px", padding: "1px" }}>
            <Image style={{ width: "850px", position: "absolute", marginLeft: "-15px", marginTop: "-42px" }} src={bannerSuperior} />
            <Image style={{ width: "85px", position: "absolute", marginLeft: "90px", marginTop: "-10px" }} src={logoProvincia} />

            <Image style={{ width: "320px", position: "absolute", marginTop: "0px", marginLeft: "450px" }} src={textoIsep} />


          </View>
          <Text style={{ textAlign: "center", marginTop: "100px", paddingTop: "1px", fontSize: "36px", fontWeight: "bold" }}>C E R T I F I C A D O</Text>

          <View className='datosPersonales_legajo' style={{ textAlign: "justify", marginLeft: "75px", marginRight: "85px", paddingTop: "1px", fontSize: "12px", lineHeight: "2" }}>

            <Text style={{ textAlign: "center", paddingTop: "1px", fontSize: "18px", lineHeight: "2", marginTop: "30px", color: "#333" }}>{text1Clase1}
            </Text>
            <Text style={{ textAlign: "center", paddingTop: "1px", fontSize: "18px", lineHeight: "2", color: "#333" }}><Text style={{ textAlign: "center", fontSize: "18px", color: "black" }}>{text2Clase1}</Text>
            </Text>
            <Text style={{ textAlign: "justify", paddingTop: "1px", fontSize: "18px", lineHeight: "2", color: "#333" }}>{text3Clase1}<Text style={{
              textAlign: "justify",
              paddingTop: "1px",
              fontSize: "16px",
              lineHeight: "2",
              color: "#333",
              textDecoration: "underline"
            }}>
              Duración:
            </Text>{datosVarios.cantidadHoras}.
            </Text>
            <Text style={{ textAlign: "rigth", fontSize: "16px", lineHeight: "2", color: "#333" }}>{"" + text4Clase1}</Text>
            <Text style={{ textAlign: "rigth", fontSize: "16px", lineHeight: "2" }}></Text>
            
             <View id="firmaDardo" style={{ width: "180px", position: "absolute", marginLeft: "350px", marginTop: "370px", lineHeight: "1", fontSize: "8px", textAlign: "center" }}>

              <Image style={{ width: "120px", position: "absolute", marginLeft: "20px", marginTop: "-90px",   transform: 'rotate(90deg)',}} src={firmaFunc} />

              <Text style={{ marginTop: "-10px" }} >{firmanteSimil}</Text>
              <Text style={{ textAlign: "center", }}>{firmanteFuncion}</Text>
              <Text >{firmanteDestino}</Text>

            </View>
            
            <View id="firmaDire" style={{ width: "110px", position: "absolute", marginLeft: "180px", marginTop: "272px", lineHeight: "1", fontSize: "8px", textAlign: "center" }}>
              <Image src={datosVarios.firma1} />
              <Text style={{ marginTop: "-10px" }} >{datosVarios.firmante1}</Text>
              <Text style={{ textAlign: "center", }}>{datosVarios.firmante1jer}</Text>
              <Text >{datosVarios.firmante1cargo}</Text>

            </View>
           
            <View id="QR" style={{ width: "150px", position: "absolute", marginLeft: "615px", marginTop: "300px" }}>
              <ImagenQR direccion={direccion} tamaño="110" /></View>
          </View>
          <View style={{ fontWeight: "bold", textAlign: "center", fontSize: "6px", position: "absolute", marginTop: "550px" }}>
            <Text style={{ fontSize: "8px", lineHeight: "2", marginLeft: "646px" }}>Nro. de Registro:{datosVarios.idCurso + "-" + datosVarios.idCursante + "-" + obtenerAnio(anio)}</Text>
          </View>
          <Image style={{ width: "850px", position: "absolute", marginLeft: "-15px", marginTop: "565px" }} src={bannerInferior} />
        </View>

      </Page>
    </Document>
  );
  const clase2 /*Certificado Titulos en tramite*/ = () => (
    <Document title={"Certificado " + datosVarios.tituloCertificado + " " + datosVarios.apellidoNombre} onLoadError={console.error}>
      <Page size="A4"  >
        <View style={{ width: "100%", marginTop: "20px", marginLeft: "10px", padding: "1px" }}>
          <View id="Logos" style={{ width: "100%", marginTop: "20px", padding: "1px" }}>
            <Text style={{ textAlign: "center", marginTop: "10px", paddingTop: "1px", fontSize: "8px", fontWeight: "bold", position: "absolute", marginLeft: "150px" }}>Alem 2050 – CP 2000 Rosario - www.isepsantafe.edu.ar – titulosisep@isepsantafe.edu.ar</Text>
            <Image style={{ width: "650px", position: "absolute", marginLeft: "-15px", marginTop: "-42px" }} src={bannerSuperior} />
            <Image style={{ width: "65px", position: "absolute", marginLeft: "60px", marginTop: "20px" }} src={logoProvincia} />

            <Image style={{ width: "280px", position: "absolute", marginTop: "40px", marginLeft: "290px" }} src={textoIsep} />


          </View>

          <Text style={{ textAlign: "center", marginTop: "130px", paddingTop: "1px", fontSize: "32px", fontWeight: "bold" }}>Certificación</Text>

          <View className='datosPersonales_legajo' style={{ textAlign: "justify", marginLeft: "75px", marginRight: "85px", paddingTop: "1px", fontSize: "12px", lineHeight: "2" }}>


            <Text style={{ textAlign: "justify", paddingTop: "1px", lineHeight: "2", marginTop: "50px", color: "#333" }}>{text1}<Text style={{ textAlign: "justify", fontSize: "12px", color: "black" }}>{text2}</Text>{text3}{text4}
            </Text>
            <Text>CUE: 8204429-01.-
            </Text>
            <Text>
              Fecha de Egreso {datosVarios.fechaRealizado}.-
            </Text>
            <Text>
              Cohorte {datosVarios.reginterno}.
            </Text>
            <Text>
              Plan de Estudios:{datosVarios.resolucionJPP}.-
            </Text>
            <Text>
              Total Horas Cátedras:  {datosVarios.cantidadHoras}.-
            </Text>

            <Text style={{ textAlign: "rigth", lineHeight: "2", color: "#333" }}>A pedido del interesado se extiende la presente constancia en {datosVarios.ciudadCertificado}, {fechaFormateadaArgentina()}, para ser presentado ante quien corresponda.</Text>
            <Text style={{ textAlign: "rigth", fontSize: "16px", lineHeight: "2" }}></Text>
            <View id="firmaDardo" style={{ width: "180px", position: "absolute", marginLeft: "230px", marginTop: "470px", lineHeight: "1", fontSize: "8px", textAlign: "center" }}>

              <Image style={{ width: "120px", position: "absolute", marginLeft: "20px", marginTop: "-90px" }} src={firmaFunc} />

              <Text style={{ marginTop: "-10px" }} >{firmanteSimil}</Text>
              <Text style={{ textAlign: "center", }}>{firmanteFuncion}</Text>
              <Text >{firmanteDestino}</Text>

            </View>
            
            <View id="firmaDire" style={{ width: "110px", position: "absolute", marginLeft: "40px", marginTop: "372px", lineHeight: "1", fontSize: "8px", textAlign: "center" }}>
              <Image src={datosVarios.firma1} />
              <Text style={{ marginTop: "-10px" }} >{datosVarios.firmante1}</Text>
              <Text style={{ textAlign: "center", }}>{datosVarios.firmante1jer}</Text>
              <Text >{datosVarios.firmante1cargo}</Text>

            </View>

            <View id="QR" style={{ width: "150px", position: "absolute", marginLeft: "400px", marginTop: "530px" }}>
              <ImagenQR direccion={direccion} tamaño="110" /></View>
          </View>
          <View style={{ fontWeight: "bold", textAlign: "center", fontSize: "6px", position: "absolute", marginTop: "800px" }}>
            <Text style={{ fontSize: "8px", lineHeight: "2", marginLeft: "456px" }}>Nro. de Registro:{datosVarios.idCurso + "-" + datosVarios.idCursante + "-" + obtenerAnio(anio)}</Text>
          </View>
          <Image style={{ width: "850px", position: "absolute", marginLeft: "-15px", marginTop: "810px" }} src={bannerInferior} />
        </View>

      </Page>
    </Document>
  );
  const clase3 /*Certificado Extension Comunitaria*/ = () => (
    <Document title={"Certificado " + datosVarios.tituloCertificado + " " + datosVarios.apellidoNombre} onLoadError={console.error}>
      <Page size="A4"  >
        <View style={{ width: "100%", marginTop: "20px", marginLeft: "10px", padding: "1px" }}>
          <View id="Logos" style={{ width: "100%", marginTop: "20px", padding: "1px" }}>
            <Text style={{ textAlign: "center", marginTop: "10px", paddingTop: "1px", fontSize: "8px", fontWeight: "bold", position: "absolute", marginLeft: "150px" }}>Alem 2050 – CP 2000 Rosario - www.isepsantafe.edu.ar – titulosisep@isepsantafe.edu.ar</Text>
            <Image style={{ width: "650px", position: "absolute", marginLeft: "-15px", marginTop: "-42px" }} src={bannerSuperior} />
            <Image style={{ width: "65px", position: "absolute", marginLeft: "60px", marginTop: "20px" }} src={logoProvincia} />

            <Image style={{ width: "280px", position: "absolute", marginTop: "40px", marginLeft: "290px" }} src={textoIsep} />


          </View>

          <Text style={{ textAlign: "center", marginTop: "130px", paddingTop: "1px", fontSize: "32px", fontWeight: "bold" }}>Certificación</Text>

          <View className='datosPersonales_legajo' style={{ textAlign: "justify", marginLeft: "75px", marginRight: "85px", paddingTop: "1px", fontSize: "12px", lineHeight: "2" }}>


            <Text style={{ textAlign: "justify", paddingTop: "1px", lineHeight: "2", marginTop: "50px", color: "#333" }}>{text1}<Text style={{ textAlign: "justify", fontSize: "12px", color: "black" }}>{text2} </Text>{text3b}
            </Text>
            <Text>CUE: 8204429-01.-
            </Text>
            <Text>
              Cohorte {datosVarios.reginterno}.
            </Text>
            <Text>
              Plan de Estudios:{datosVarios.resolucionJPP}.-
            </Text>


            <Text style={{ textAlign: "rigth", lineHeight: "2", color: "#333" }}>A pedido del interesado se extiende la presente constancia en {datosVarios.ciudadCertificado}, {fechaFormateadaArgentina()}, para ser presentado ante quien corresponda.</Text>
            <Text style={{ textAlign: "rigth", fontSize: "16px", lineHeight: "2" }}></Text>
             <View id="firmaDardo" style={{ width: "180px", position: "absolute", marginLeft: "350px", marginTop: "370px", lineHeight: "1", fontSize: "8px", textAlign: "center" }}>

              <Image style={{ width: "120px", position: "absolute", marginLeft: "20px",  transform: 'rotate(-90deg)'}} src={firmaFunc} />

              <Text style={{ marginTop: "-10px" }} >{firmanteSimil}</Text>
              <Text style={{ textAlign: "center", }}>{firmanteFuncion}</Text>
              <Text >{firmanteDestino}</Text>

            </View>
            
            <View id="firmaDire" style={{ width: "110px", position: "absolute", marginLeft: "180px", marginTop: "272px", lineHeight: "1", fontSize: "8px", textAlign: "center" }}>
              <Image src={datosVarios.firma1} />
              <Text style={{ marginTop: "-10px" }} >{datosVarios.firmante1}</Text>
              <Text style={{ textAlign: "center", }}>{datosVarios.firmante1jer}</Text>
              <Text >{datosVarios.firmante1cargo}</Text>

            </View>

            <View id="QR" style={{ width: "150px", position: "absolute", marginLeft: "400px", marginTop: "530px" }}>
              <ImagenQR direccion={direccion} tamaño="110" /></View>
          </View>
          <View style={{ fontWeight: "bold", textAlign: "center", fontSize: "6px", position: "absolute", marginTop: "800px" }}>
            <Text style={{ fontSize: "8px", lineHeight: "2", marginLeft: "456px" }}>Nro. de Registro:{datosVarios.idCurso + "-" + datosVarios.idCursante + "-" + obtenerAnio(anio)}</Text>
          </View>
          <Image style={{ width: "850px", position: "absolute", marginLeft: "-15px", marginTop: "810px" }} src={bannerInferior} />
        </View>

      </Page>
    </Document>
  );
  const clase4 /*Certificado Secretaria Academica*/ = () => (
    <Document title={"Certificado " + datosVarios.tituloCertificado + " " + datosVarios.apellidoNombre} onLoadError={console.error}>
      <Page size="A4" orientation='landscape' >
        <View style={{ width: "100%", marginTop: "20px", marginLeft: "10px", padding: "1px" }}>
          <View id="Logos" style={{ width: "100%", marginTop: "20px", padding: "1px" }}>
            <Image style={{ width: "850px", position: "absolute", marginLeft: "-12px", marginTop: "-42px" }} src={bannerSuperior} />
            <Image style={{ width: "85px", position: "absolute", marginLeft: "90px", marginTop: "-10px" }} src={logoProvincia} />

            <Image style={{ width: "320px", position: "absolute", marginTop: "0px", marginLeft: "450px" }} src={textoIsep} />


          </View>
          <Text style={{ textAlign: "center", marginTop: "100px", paddingTop: "1px", fontSize: "28px", fontWeight: "bold" }}>CERTIFICADO DE FINALIZACIÓN DE CURSO</Text>

          <View className='datosPersonales_legajo' style={{ textAlign: "justify", marginLeft: "75px", marginRight: "85px", marginTop: "10px", paddingTop: "1px", fontSize: "12px", lineHeight: "2" }}>

            <Text style={{ textAlign: "justify", paddingTop: "1px", fontSize: "16px", lineHeight: "2", marginTop: "30px", color: "#333" }}>{text1Clase4}<Text style={{ textAlign: "justify", fontSize: "16px", color: "black" }}>{text2Clase4}</Text>{text3Clase4}
            </Text>
            <Text style={{ textAlign: "justify", paddingTop: "1px", fontSize: "16px", lineHeight: "2", color: "#333" }}>Se extiende el presente en la ciudad de {ciudadMayuscula + ": " + hoyClase4 + "."}
            </Text>


            <Text style={{ textAlign: "rigth", fontSize: "16px", lineHeight: "2" }}></Text>
                     <View id="firmaDardo" style={{ width: "180px", position: "absolute", marginLeft: "350px", marginTop: "370px", lineHeight: "1", fontSize: "8px", textAlign: "center" }}>

              <Image style={{ width: "120px", position: "absolute", marginLeft: "20px",  marginTop: "-85px", transform: 'rotate(-90deg)'}} src={firmaFunc} />

              <Text style={{ marginTop: "-10px" }} >{firmanteSimil}</Text>
              <Text style={{ textAlign: "center", }}>{firmanteFuncion}</Text>
              <Text >{firmanteDestino}</Text>

            </View>
            
            <View id="firmaDire" style={{ width: "110px", position: "absolute", marginLeft: "180px", marginTop: "272px", lineHeight: "1", fontSize: "8px", textAlign: "center" }}>
              <Image src={datosVarios.firma1} />
              <Text style={{ marginTop: "-10px" }} >{datosVarios.firmante1}</Text>
              <Text style={{ textAlign: "center", }}>{datosVarios.firmante1jer}</Text>
              <Text >{datosVarios.firmante1cargo}</Text>

            </View>

            <View id="QR" style={{ width: "150px", position: "absolute", marginLeft: "615px", marginTop: "300px" }}>
              <ImagenQR direccion={direccion} tamaño="110" /></View>
          </View>
          <View style={{ fontWeight: "bold", textAlign: "center", fontSize: "6px", position: "absolute", marginTop: "550px" }}>
            <Text style={{ fontSize: "8px", lineHeight: "2", marginLeft: "646px" }}>Nro. de Registro:{datosVarios.idCurso + "-" + datosVarios.idCursante + "-" + obtenerAnio(anio)}</Text>
          </View>
          <Image style={{ width: "850px", position: "absolute", marginLeft: "-15px", marginTop: "565px" }} src={bannerInferior} />
        </View>

      </Page>
    </Document>
  );
  const clases = {
    clase1,
    clase2,
    clase3, clase4,
    // etc.
  };

  // Supongamos que esto viene de la base de datos:
  const claseCertificados = datosVarios.claseCertificado; // por ejemplo

  const MyDocument = clases[claseCertificados];
//   console.log(datosVarios)

  const generatePdfDocument = async () => {
    try {
      const nombreArchivo = "Certificado " + datosVarios.tituloCertificado + " " + datosVarios.apellidoNombre
      const doc = <MyDocument />
      const blob = await pdf(doc).toBlob();
      saveAs(blob, nombreArchivo);
    } catch (error) {

    }
  };
  // Componente principal del visor PDF
  return (<>
    {<>
      {muestro ? <> {width < 480 ? <><div style={{ textAlign: "center" }}>
        <img src={Logo} style={{ width: "100px" }}></img>
        <h1>Descargue su certificado {datosVarios.apellidoNombre}</h1>
        <button className="btn btn-primary" onClick={generatePdfDocument}>DESCARGAR</button></div></> :
        <>
          <PDFViewer showToolbar="false" style={{ width: "100%", height: "100vh" }} >
            <MyDocument />
          </PDFViewer></>}</> : <>{Er ? <><div style={{ textAlign: 'center', margin: "10px", border: "1px solid red", padding: "5px" }}><img src={logoProvincia} width="120px" alt="Escudo" />
            <h1 style={{ textAlign: 'center', marginTop: '10px', color: "red" }}>{"Error al obtener los datos o datos Invalidos"}</h1>
            <h6>Comuniquese al area de Extensión comunitaria "extensioncomunitaria@isepsantafe.edu.ar" si considera que es un error  </h6></div></> : ""}</>}




    </>}


  </>

  );
}
export default Constancia